module.exports = __webpack_public_path__ + "static/paintings-thumbnail-079a9b37ebf45d32baa80c48aa739b2b.jpg";